// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from NotificationsList.module.scss  */
/* stylelint-disable */
@media (max-width: 767px) {
  .NotificationsList-module-Root_2qp.NotificationsList-module-isMobile_1oa {
    position: fixed;
    z-index: 250;
    top: 8px;
    left: 8px;
    width: calc(100% - 16px);
    pointer-events: none;
    touch-action: none; }
    .NotificationsList-module-Root_2qp.NotificationsList-module-isMobile_1oa > .NotificationsList-module-Element_1YZ {
      pointer-events: all;
      touch-action: auto; }
    .NotificationsList-module-Root_2qp.NotificationsList-module-isMobile_1oa .NotificationsList-module-Element_1YZ:not(:last-child):not(:nth-last-child(2)) {
      visibility: hidden;
      opacity: 0; }
    .NotificationsList-module-Root_2qp.NotificationsList-module-isMobile_1oa .NotificationsList-module-PseudoElement_3PX {
      display: block; }
  .NotificationsList-module-Root_2qp.NotificationsList-module-animationIn_7WR .NotificationsList-module-PseudoElement_3PX {
    opacity: 1;
    transform: translateY(8px); }
  .NotificationsList-module-Root_2qp.NotificationsList-module-animationOut_2MU .NotificationsList-module-PseudoElement_3PX {
    opacity: 0;
    transition: transform 0.2s linear 0s, opacity 0.1s linear 0s;
    transform: translateY(0); } }

.NotificationsList-module-Root_2qp:empty {
  display: none; }

.NotificationsList-module-Element_1YZ {
  width: 100%;
  max-width: 440px; }
  @media (max-width: 767px) {
    .NotificationsList-module-Element_1YZ {
      z-index: 199;
      max-width: 100%;
      margin: 0 !important; } }

.NotificationsList-module-PseudoElement_3PX {
  display: none; }
  @media (max-width: 767px) {
    .NotificationsList-module-PseudoElement_3PX {
      position: absolute;
      z-index: 0;
      bottom: 0;
      left: 8px;
      width: calc(100% - 16px);
      height: 100%;
      opacity: 0;
      border-radius: 16px;
      background-color: var(--notification-minified-background-color);
      transition: transform 0.4s linear 0.55s, opacity 0.2s linear 0.55s;
      will-change: transform; } }

[data-variant='dark'] + .NotificationsList-module-PseudoElement_3PX {
  background-color: var(--notification-dark-minified-background-color); }

@keyframes NotificationsList-module-showPseudoElement_10a {
  from {
    opacity: 0;
    transform: translateY(0); }
  to {
    opacity: 1;
    transform: translateY(8px); } }

@keyframes NotificationsList-module-hidePseudoElement_1T- {
  from {
    opacity: 1;
    transform: translateY(8px); }
  to {
    opacity: 0;
    transform: translateY(8px); } }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/NotificationsList/NotificationsList.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,wBAAwB;IACxB,oBAAoB;IACpB,kBAAkB,EAAE;IACpB;MACE,mBAAmB;MACnB,kBAAkB,EAAE;IACtB;MACE,kBAAkB;MAClB,UAAU,EAAE;IACd;MACE,cAAc,EAAE;EACpB;IACE,UAAU;IACV,0BAA0B,EAAE;EAC9B;IACE,UAAU;IACV,4DAA4D;IAC5D,wBAAwB,EAAE,EAAE;;AAEhC;EACE,aAAa,EAAE;;AAEjB;EACE,WAAW;EACX,gBAAgB,EAAE;EAClB;IACE;MACE,YAAY;MACZ,eAAe;MACf,oBAAoB,EAAE,EAAE;;AAE9B;EACE,aAAa,EAAE;EACf;IACE;MACE,kBAAkB;MAClB,UAAU;MACV,SAAS;MACT,SAAS;MACT,wBAAwB;MACxB,YAAY;MACZ,UAAU;MACV,mBAAmB;MACnB,+DAA+D;MAC/D,kEAAkE;MAClE,sBAAsB,EAAE,EAAE;;AAEhC;EACE,oEAAoE,EAAE;;AAExE;EACE;IACE,UAAU;IACV,wBAAwB,EAAE;EAC5B;IACE,UAAU;IACV,0BAA0B,EAAE,EAAE;;AAElC;EACE;IACE,UAAU;IACV,0BAA0B,EAAE;EAC9B;IACE,UAAU;IACV,0BAA0B,EAAE,EAAE","sourcesContent":["/*  imported from NotificationsList.module.scss  */\n/* stylelint-disable */\n@media (max-width: 767px) {\n  .NotificationsList-module-Root_2qp.NotificationsList-module-isMobile_1oa {\n    position: fixed;\n    z-index: 250;\n    top: 8px;\n    left: 8px;\n    width: calc(100% - 16px);\n    pointer-events: none;\n    touch-action: none; }\n    .NotificationsList-module-Root_2qp.NotificationsList-module-isMobile_1oa > .NotificationsList-module-Element_1YZ {\n      pointer-events: all;\n      touch-action: auto; }\n    .NotificationsList-module-Root_2qp.NotificationsList-module-isMobile_1oa .NotificationsList-module-Element_1YZ:not(:last-child):not(:nth-last-child(2)) {\n      visibility: hidden;\n      opacity: 0; }\n    .NotificationsList-module-Root_2qp.NotificationsList-module-isMobile_1oa .NotificationsList-module-PseudoElement_3PX {\n      display: block; }\n  .NotificationsList-module-Root_2qp.NotificationsList-module-animationIn_7WR .NotificationsList-module-PseudoElement_3PX {\n    opacity: 1;\n    transform: translateY(8px); }\n  .NotificationsList-module-Root_2qp.NotificationsList-module-animationOut_2MU .NotificationsList-module-PseudoElement_3PX {\n    opacity: 0;\n    transition: transform 0.2s linear 0s, opacity 0.1s linear 0s;\n    transform: translateY(0); } }\n\n.NotificationsList-module-Root_2qp:empty {\n  display: none; }\n\n.NotificationsList-module-Element_1YZ {\n  width: 100%;\n  max-width: 440px; }\n  @media (max-width: 767px) {\n    .NotificationsList-module-Element_1YZ {\n      z-index: 199;\n      max-width: 100%;\n      margin: 0 !important; } }\n\n.NotificationsList-module-PseudoElement_3PX {\n  display: none; }\n  @media (max-width: 767px) {\n    .NotificationsList-module-PseudoElement_3PX {\n      position: absolute;\n      z-index: 0;\n      bottom: 0;\n      left: 8px;\n      width: calc(100% - 16px);\n      height: 100%;\n      opacity: 0;\n      border-radius: 16px;\n      background-color: var(--notification-minified-background-color);\n      transition: transform 0.4s linear 0.55s, opacity 0.2s linear 0.55s;\n      will-change: transform; } }\n\n[data-variant='dark'] + .NotificationsList-module-PseudoElement_3PX {\n  background-color: var(--notification-dark-minified-background-color); }\n\n@keyframes NotificationsList-module-showPseudoElement_10a {\n  from {\n    opacity: 0;\n    transform: translateY(0); }\n  to {\n    opacity: 1;\n    transform: translateY(8px); } }\n\n@keyframes NotificationsList-module-hidePseudoElement_1T- {\n  from {\n    opacity: 1;\n    transform: translateY(8px); }\n  to {\n    opacity: 0;\n    transform: translateY(8px); } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
